// import { parseNetworkError } from '../utils/request'
import * as apiMethods from '../services'
import apolloClient from '../utils/graphql/apolloClient'

export const SET_API_CALL_IN_PROGRESS = 'SET_API_CALL_IN_PROGRESS'
export const SET_GENERAL_ERRORS = 'SET_GENERAL_ERRORS'

export default {
  state: {
    isAPICallInProgress: false,
    generalErrors: []
  },
  getters: {
    isAPICallInProgress: state => state.isAPICallInProgress,
    generalErrors: state => state.generalErrors
  },
  mutations: {
    [SET_API_CALL_IN_PROGRESS]: (state, status) => {
      state.isAPICallInProgress = status
    },
    [SET_GENERAL_ERRORS]: (state, error) => {
      state.generalErrors.push(error)
    }
  },
  actions: {
    async api({ commit }, { entity, action, payload = {}, query, params }) {
      try {
        const response = await apiMethods[entity][action]({
          payload,
          query,
          params
        })

        return response
      } catch (error) {
        const errorPayload = {
          [`${entity}_${action}_request`]: error
        }

        commit(SET_GENERAL_ERRORS, errorPayload)
      }
    },
    async graphql({ commit }, query) {
      try {
        const response = await apolloClient.query({ query })
        return response
      } catch (error) {
        commit(SET_GENERAL_ERRORS, { graph: error })
      }
    },
    async timer(_, { delay = 500, callback = () => { } }) {
      return await new Promise(resolve => setTimeout(() => resolve(callback()), delay))
    }
  }
}
